import { useEffect, useRef } from "react";
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withDelay,
	withTiming,
} from "react-native-reanimated";
import { radiusSmall } from "src/styles/radius";
import { Image } from "src/swsh-native";
import { FloatingPhoto } from "../types";

const sinApprox = (x: number) => {
	"worklet";
	return x - Math.pow(x, 3) / 6 + Math.pow(x, 5) / 120 - Math.pow(x, 7) / 5040;
};

const FloatingBackgroundImage = ({
	floatingPhoto,
	yOffset,
}: {
	floatingPhoto: FloatingPhoto;
	yOffset: number;
}) => {
	const progress = useSharedValue(0);
	const animatedStyle = useAnimatedStyle(
		() => ({
			opacity: 0.6 * sinApprox(progress.value * 3.15),
			transform: [
				{
					translateY: (progress.value - 0.5) * floatingPhoto.distance,
				},
			],
		}),
		[floatingPhoto.distance, progress],
	);

	const initialFloatingPhoto = useRef(floatingPhoto);
	useEffect(() => {
		const { delay, duration } = initialFloatingPhoto.current;
		if (delay < 0) {
			progress.value = Math.min(Math.max((duration + delay) / duration, 0), 1);
			progress.value = withTiming(1, {
				duration: duration + delay,
			});
		} else {
			progress.value = withDelay(
				delay,
				withTiming(1, {
					duration,
				}),
			);
		}
	}, [progress]);

	return (
		<Animated.View
			style={[
				{
					position: "absolute",
					zIndex: -1,
					top: floatingPhoto.y + yOffset,
					left: floatingPhoto.x,
				},
				animatedStyle,
			]}
		>
			<Image
				alt="Album photo"
				dim={{
					width: floatingPhoto.width,
					height: floatingPhoto.height,
				}}
				src={floatingPhoto.src}
				style={{
					borderRadius: radiusSmall,
				}}
			/>
		</Animated.View>
	);
};
export default FloatingBackgroundImage;
